module.exports = __webpack_public_path__ + "media/images/qr/classy-rounded-005f174566398f34f78e7bad5d7a14f6.png";